import {useQuery} from "@tanstack/react-query";
import {useAxios} from "../../hooks/axios/useAxios";
import {documentRequestEndpointUrl} from "../../constants/api/endpoints";


export const useDocumentRequestsByPortfolio = (portfolio_id: string) => {
  const axios = useAxios();

  return useQuery({
    queryKey: ["document-requests", portfolio_id],
    queryFn: async () => {
      if (portfolio_id) {
        const response = await axios.get(
          documentRequestEndpointUrl,
          {
            params: {
              portfolio_id
            }
          }
        );
        return response.data.document_requests;
      }
      return [];
    },
  });
};